import { Injectable, NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthState } from '@wilson/auth/core';
import { firstValueFrom, combineLatest, map, Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { OrganizationalUnitService } from '@wilson/organizational-unit';

@NgModule({
  imports: [CommonModule],
})
@Injectable()
export class NonDomainSpecificActivitiesHelpersServicesModule {
  private store = inject(Store);
  private organizationalUnitService = inject(OrganizationalUnitService);

  async findOrgUnitWithTransportGoods(
    accessibleOrgUnitsIdAndRootOrgUnit: string[],
  ): Promise<string | null> {
    for (let i = 0; i < accessibleOrgUnitsIdAndRootOrgUnit.length; i++) {
      const organizationalUnit = await firstValueFrom(
        this.organizationalUnitService.getOrganizationalUnit(
          accessibleOrgUnitsIdAndRootOrgUnit[i],
          ['organizationalUnitTransportGoods'],
        ),
      );

      if (
        organizationalUnit.organizationalUnitTransportGoods &&
        organizationalUnit.organizationalUnitTransportGoods.length > 0
      ) {
        return organizationalUnit.id as string;
      }
    }

    return null;
  }

  getAccessibleAndRootOrgUnitIds(): Observable<string[]> {
    return combineLatest([
      this.store.select(AuthState.organizationalUnitId),
      this.store.select(AuthState.accessibleOrgUnits),
    ]).pipe(
      map(([rootOrgUnitId, accessibleOrgUnits]) => {
        const orgUnitId = rootOrgUnitId || '';
        const accessibleOrgUnitsIds: string[] =
          (accessibleOrgUnits?.map((unit) => unit.id) as string[]) || [];

        const accessibleOrgUnitsIdAndRootOrgUnit: string[] = Array.from(
          new Set([orgUnitId, ...accessibleOrgUnitsIds]),
        );

        return accessibleOrgUnitsIdAndRootOrgUnit;
      }),
    );
  }
}
